<template>
  <div class="location-card">
    <b-card no-body border-variant="light" class="form-card bg-white">
      <b-container fluid>
        <b-row no-gutters id="contact-row" class="contact-row">
          <b-col lg="8" md="6" sm="6" xs="6">
            <div class="location-headings">
              <Headings :data="locationName" />
            </div>
            <b-row>
              <b-col md="2" sm="2" class="address address-icon">
                <img :src="require(`@/assets/${locationMarker}`)" />
              </b-col>
              <b-col v-if="locationName == 'Mumbai'" md="10" sm="8" class="address address-text">
                <p v-bind:class="[locationName == 'Mumbai' ? 'mStyle' : '']">Address: {{ locatiodAddress }}</p>
              </b-col>
              <b-col v-else md="10" sm="8" class="address address-text">
                <p v-bind:class="[locationName == 'Hyderabad' || locationName == 'Chennai' ? 'pStyle' : '']">Address: {{ locatiodAddress }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2" sm="2" class="number phone-icon">
                <img :src="require(`@/assets/${callIcon}`)" />
              </b-col>
              <b-col md="10" sm="8" class="number text-left phone-text">
                <p>{{ locationNumber }}</p>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" sm="6" xs="6" class="cityicon">
            <img :src="require(`@/assets/${locationImage}`)" />
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "Locationcard",
  props: [
    "locationName",
    "locationNumber",
    "locatiodAddress",
    "locationMarker",
    "locationImage",
    "callIcon",
  ],
};
</script>
<style scoped>
.pStyle {
  margin-bottom:0.2rem;
}
.mStyle {
  margin-bottom:2rem;
}
.form-card {
  border-radius: 1.25rem;
  width: 100%;
  /*box-shadow: 0 0 8px #d0d0d0; */
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  border: 0px solid #d3d3d3;
  justify-content: center;
  margin-bottom: 2rem;
  padding: 1rem;
}
.location-headings {
  color: var(--mainBlueColor);
  font-size: 2rem;
}
.number {
  color: var(--mainBlueColor);
  font-size: 0.7rem;

  text-align: left;
}
.address {
  color: var(--mainBlueColor);
  font-size: 0.7rem;
  padding-top: 1rem;
  text-align: left;
}
.address > img {
  width: 3rem;
  float: left;
  padding-right: 1rem;
  margin-bottom: 0.25rem;
}
.number > img {
  width: 2rem;
  float: left;
  padding-right: 1rem;
  margin-left: 0.5rem;
  margin-top: 0.25rem;
}
.cityicon > img {
  width: 100%;
}
.contact-row {
  height: 100%;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.cityicon > img {
  padding-top: 3rem;
}
@media (min-width: 481px) and (max-width: 767px) {
  .contact-row {
    padding-top: 1rem;
    padding-bottom: 1rem;
    text-align: center;
  }
  .location-headings {
    font-size: 1.4rem;
    font-weight: 600;
    padding-bottom:1rem;
  }
  .address,
  .number {
  }
  .address > img {
    /*  width: 20%; */
    padding-right: 1rem;
    float: left;
    display: inline;
  }
  .address > p {
    float: right;
    display: inline;
  }
  .number > img {
    /* width: 9%;
        height: 18%;*/
    width: 19px;
    padding-right: 0.25rem;
  }
  .cityicon > img {
    width: 72%;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .address-icon {
    width: 10%;
  }

  .address-text {
    width: 82%;
    margin-left: 10px;
  }

  .phone-icon {
    width: 8%;
  }

  .phone-text {
    width: 82%;
    margin-left: 10px;
  }
  .form-card {
    padding: 0;
  }
}
@media (max-width: 480px) {
  .contact-row {
    padding-top: 1rem;
    padding-bottom: 1rem;
    text-align: center;
  }
  .location-headings {
    font-size: 1.4rem;
    font-weight: 600;
  }
  .address,
  .number {
  }
  .address > img {
    /*  width: 20%; */
    padding-right: 1rem;
    float: left;
    display: inline;
  }
  .address > p {
    float: right;
    display: inline;
  }
  .number > img {
    /* width: 9%;
        height: 18%;*/
    width: 19px;
    padding-right: 0.25rem;
  }
  .cityicon > img {
    width: 35%;
    padding-top: 0;
  }
  .address-icon {
    width: 10%;
  }

  .address-text {
    width: 82%;
    margin-left: 10px;
  }

  .phone-icon {
    width: 8%;
  }

  .phone-text {
    width: 82%;
    margin-left: 10px;
  }
  .form-card {
    padding: 0;
  }
}
</style>
